// @ts-check
import { getAll } from "../utilities/querySelector";

const triggers = getAll( '[data-modal-open="enquiry"]' );
const selects = getAll( '[data-hut-select]' );

triggers.forEach( trigger => trigger.addEventListener( 'click', () => {
    const name = trigger.dataset.hut;
    if ( !name ) return;
    selects.forEach( select => {
        select.value = name;
    } );
} ) );